export { default } from './game';
